<template>
  <div>
    <div class="app-header">
      <div class="bread-crumb">
        <ul class="list-item-container">
          <li v-for="(item, index) in arrayStep" class="list-item" :key="item">
            <a href="javascript:void(0)" class="step-name-breadcrumb body-text scheduler-text-custom-color">{{item}}</a>
            <div class="arrow-icon" v-if="index != arrayStep.length - 1" role="navigation"></div>
          </li>
        </ul>
      </div>
    </div>

    <div class="animated fadeIn my-appointment-page body-content">
      <div>
        <h1 class="step-name h1-text" tabindex="0" ref="focusTab">My Appointments</h1>
        <div>
          <div>
            <div class="my-appointment-info common-card scheduler-card-responsive">
              <div class="map-wrapper">
                <div class="map-auto-detection">
                  <img :src="imgSrc">
                </div>
              </div>
              <div class="group-button">
                <button class="ap-btn scheduler-button-custom-color secondary-custom cancel-btn"
                        role="button">
                  <div class="content">Cancel</div>
                </button>
                <button class="ap-btn scheduler-button-custom-color reschedule-btn"
                        role="button">
                  <div class="content">Reschedule</div>
                </button>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <div class="appointment-info">
                    <div class="client-info">
                      <div class="calender-wrapper">
                        <div class="calendar-icon" aria-label="Event icon"></div>
                        <div class="">
                          <div class="title-text label-text scheduler-text-custom-color">Event</div>
                          <div class="client-name field-value body-text">{{event.companyName}} Event {{event.prefDate}}</div>
                          <div class="body-text type-flushot">

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="event-info">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <div class="date-wrapper">
                            <div class="title-text label-text scheduler-text-custom-color">Date</div>
                            <div class="field-value body-text">{{event.prefDate}}</div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                          <div class="time-wrapper">
                            <div v-if="event.hasSpouse">
                              <div class="title-text label-text scheduler-text-custom-color">Time</div>
                              <div class="field-value body-text time-slots">
                                <div>{{'Myself - ' + event.timeSlot}}</div>
                                <div class="space">,&nbsp;</div>
                                <div></div>
                              </div>
                            </div>
                            <div v-else>
                              <div class="title-text label-text scheduler-text-custom-color">Time</div>
                              <div class="field-value body-text">
                                {{event.timeSlot}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="room-location-wrapper">
                        <div class="row">
                          <div class="col-sm-6 col-xs-12">
                            <div class="location-wrapper">
                              <div class="location-icon" aria-label="Location icon"></div>
                              <div class="">
                                <div class="title-text label-text scheduler-text-custom-color">Location</div>
                                <div class="field-value body-text">{{event.building ? event.building + ', ' : ''}}{{event.fullAddress}}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 col-xs-12">
                            <div class="room-wrapper">
                              <div class="title-text label-text scheduler-text-custom-color">Room</div>
                              <div class="field-value body-text">
                                {{event.eventLocation}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="group-button-for-small">
                <button id="rescheduleApptBtn" class="ap-btn scheduler-button-custom-color reschedule-btn" role="button">
                  <div class="content">Reschedule</div>
                </button>
                <button id="cancelApptBtn" class="ap-btn scheduler-button-custom-color secondary-custom cancel-btn" role="button">
                  <div class="content">Cancel</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-information common-card scheduler-card-responsive margin-top-24px" v-if="landingThankYouText !== ''">
      <div class="body-text" v-html="landingThankYouText"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'schedulerPreviewMyAppointmentPage',
    components: {},
    props: {
      landingThankYouText: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        imgSrc: '../../../../static/img/googleMapPreview.png',
        arrayStep: [],
        event: {
          companyName: 'Company Name',
          prefDate: '01/01/2021',
          hasSpouse: false,
          timeSlot: '6:00AM',
          eventLocation: 'Event Location',
          building: 'Event Building',
          fullAddress: 'Event Full Address'
        }
      }
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .app-header{
    background-color: white;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.2), 0 2px 1px 1px rgba(0,0,0,0.1);
    margin-top: 24px;
    height: auto;
    padding: 28px 48px;
    width: 100%;
    overflow: auto;
  }

  .bread-crumb{
    padding: 8px 0 8px 48px;
    width: 810px;
    margin: auto;
  }

  .my-appointment-page{
    padding: 24px 40px;
    width: 810px;
    margin: auto;

    .my-appointment-info{
      margin-top: 20px;

      .map-wrapper{
        min-height: 120px;
        height: 300px;

        .map-auto-detection{
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }

          #tileCanvasId{
            border-radius: 4px 4px 0 0;
          }
        }
      }

      .appointment-info{
        margin-top: 24px;
        padding-left: 40px;
        padding-bottom: 25px;

        .client-info{

          .calender-wrapper{
            display: flex;

            .calendar-icon{
              width: 24px;
              height: 24px;
              background: url('../../../../static/img/24px-calendar.svg') no-repeat center;
              margin-right: 16px;
            }
          }
          .type-flushot{
            color: black;
          }

        }

        .event-info{
          margin-top: 24px;

          .date-wrapper{
            margin-left: 40px;
          }

          .time-wrapper{
            .time-slots{
              display: flex;
              justify-content: flex-start;
              text-transform: capitalize;
            }
          }

          .room-location-wrapper{
            margin-top: 24px;

            .location-wrapper{
              display: flex;

              .location-icon{
                width: 24px;
                height: 24px;
                margin-right: 16px;
                background: url('../../../../static/img/24px-distance.svg') no-repeat center;
              }
            }
          }
        }

        .title-text{
          font-weight: bold;
          text-transform: uppercase;
        }
        .field-value{
          margin-top: 8px;
          color: black;
        }
      }

      .group-button{
        display: flex;
        justify-content: center;
        margin-top: -24px;
        position: relative;

        .reschedule-btn{
          padding: 12px 32px;
          margin-left: 24px;
        }
        .cancel-btn{
          padding: 12px 32px;
        }
      }
      .group-button-for-small{
        display: none;
      }
      @include media-breakpoint-down(sm) {
        .time-wrapper{
          .time-slots{
            display: flex;
            flex-direction: column;

            .space{
              display: none;
            }
          }
        }
      }
      @include media-breakpoint-down(xs) {
        .map-wrapper{
          margin: -16px -16px 0;
        }

        .appointment-info{
          .time-wrapper, .room-wrapper{
            margin-left: 40px;
            margin-top: 16px;
          }

          .time-wrapper{
            .time-slots{
              display: flex;
              flex-direction: column;

              .space{
                display: none;
              }
            }
          }
        }

        .group-button{
          display: none;
        }

        .group-button-for-small{
          display: block;
          margin-top: 24px;

          .reschedule-btn{
            width: 100%;
          }
          .cancel-btn{
            width: 100%;
            margin-top: 16px;
          }
        }
      }
    }
  }

  .more-information {
    padding: 20px;
    width: 730px;
    margin: auto;
    margin-bottom: 55px;
  }

</style>



// WEBPACK FOOTER //
// SchedulerPreviewMyAppointmentPage.vue?b513440e